// Single source of truth for the app's supported languages and the locale
// normalization rules shared by app.component (UI language) and
// conference.service (content dataset). To add a language, add it here (and
// ship the matching assets/i18n/<code>.json + assets/data/data.<code>.json,
// and a flag in assets/img/flags/).

export interface AppLanguage {
  code: string;
  label: string;
  /**
   * The flag shown beside the language in the menu, from assets/img/flags/
   * (SVG, not emoji: Windows doesn't draw flag emoji). A language is not a
   * country, so this is the flag readers most associate with it.
   */
  flag: string;
}

export const LANGUAGES: AppLanguage[] = [
  { code: 'en', label: 'English', flag: 'assets/img/flags/gb.svg' },
  { code: 'es', label: 'Español', flag: 'assets/img/flags/es.svg' },
  { code: 'fr', label: 'Français', flag: 'assets/img/flags/fr.svg' },
  { code: 'nl', label: 'Nederlands', flag: 'assets/img/flags/nl.svg' },
  { code: 'de', label: 'Deutsch', flag: 'assets/img/flags/de.svg' },
];

export const SUPPORTED_LANG_CODES = LANGUAGES.map(l => l.code);

// Reduce a raw locale (e.g. 'fr-CA', 'EN') to its lowercase 2-letter code,
// or undefined when there's nothing usable (null/undefined/empty).
export function toLangCode(raw: string | null | undefined): string | undefined {
  return raw?.split('-')[0].toLowerCase() || undefined;
}
